import { render, staticRenderFns } from "./GroupAddDialog.vue?vue&type=template&id=5a86405a"
import script from "./GroupAddDialog.vue?vue&type=script&lang=js"
export * from "./GroupAddDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports